import { FaInstagram, FaTiktok } from "react-icons/fa6";

export const navItems = [
  { to: "/hardware", label: "Hardware" },
  { to: "/event", label: "Event" },
  { to: "/journal", label: "Journal" },
  { to: "/contact", label: "Contact" },
];

export const socialLinks = [
  { href: "https://www.instagram.com/", label: "Instagram", Icon: FaInstagram },
  { href: "https://www.tiktok.com/", label: "TikTok", Icon: FaTiktok },
];
